<app-bs-alert *ngFor="let alert of alerts" [alert]="alert"></app-bs-alert>
